import { Controller } from "@hotwired/stimulus"

// FD-426: a searchable single-select that writes its choice into a hidden field in
// the SURROUNDING form WITHOUT submitting — for pickers that sit in a form next to
// other inputs (a role select) and an explicit submit button. Pair with
// shared/_combobox. (popover_select submits on pick, so it doesn't fit this case.)
export default class extends Controller {
  static targets = ["field", "trigger", "panel", "search", "option"]

  connect() {
    this._onDoc = (e) => { if (!this.element.contains(e.target)) this.close() }
    // FD-573: Escape closes the panel, like every other popup surface. stopPropagation so a
    // combobox inside a <dialog> dismisses only itself, not the dialog (popover_controller does
    // the same). Escape cancels the menu — it never clears the already-picked value.
    this._onKeydown = (e) => {
      if (e.key !== "Escape") return
      e.stopPropagation()
      this.close()
    }
  }

  disconnect() {
    this.teardown()
  }

  toggle(event) {
    event.preventDefault()
    this.panelTarget.hidden ? this.open() : this.close()
  }

  open() {
    this.panelTarget.hidden = false
    document.addEventListener("click", this._onDoc, true)
    document.addEventListener("keydown", this._onKeydown, true)
    if (this.hasSearchTarget) {
      this.searchTarget.value = ""
      this.filter()
      // FD-1190: the search box sits just under the trigger the user clicked; don't scroll to it.
      requestAnimationFrame(() => this.searchTarget.focus({ preventScroll: true }))
    }
  }

  close() {
    if (this.panelTarget.hidden) return
    this.panelTarget.hidden = true
    this.teardown()
  }

  teardown() {
    document.removeEventListener("click", this._onDoc, true)
    document.removeEventListener("keydown", this._onKeydown, true)
  }

  pick(event) {
    const opt = event.currentTarget
    this.fieldTarget.value = opt.dataset.value
    this.triggerTarget.textContent = opt.dataset.comboboxName
    this.close()
  }

  filter() {
    if (!this.hasSearchTarget) return
    const query = this.searchTarget.value.trim().toLowerCase()
    this.optionTargets.forEach((opt) => {
      const name = (opt.dataset.comboboxName || "").toLowerCase()
      opt.hidden = query !== "" && !name.includes(query)
    })
  }
}
